export var HttpCode;
(function (HttpCode) {
    HttpCode[HttpCode["NOT_FOUND"] = 404] = "NOT_FOUND";
    HttpCode[HttpCode["GONE"] = 410] = "GONE";
    HttpCode[HttpCode["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpCode[HttpCode["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    /**
     * Typically used in the RoutingAPI (GeoServices) when requested points exceed a certain distance, triggering a 422 response before a timeout occurs.
     * @link https://avivgroup.atlassian.net/wiki/spaces/AGRS/pages/204505110/AVIV+Geo+Services
     */
    HttpCode[HttpCode["UNPROCESSABLE_CONTENT"] = 422] = "UNPROCESSABLE_CONTENT";
})(HttpCode || (HttpCode = {}));
export var HttpStatus;
(function (HttpStatus) {
    HttpStatus["TIMEOUT"] = "timeout";
    HttpStatus["BROKEN_LINK"] = "broken link";
    HttpStatus["UNPUBLISHED"] = "unpublished";
    HttpStatus["DELETED"] = "deleted";
    HttpStatus["TECHNICAL_ERROR"] = "technical error";
})(HttpStatus || (HttpStatus = {}));
export const bffTimeout = 10 * 1000;
